// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2H2NQ","error":"Textarea_error__1X7ng","readonly":"Textarea_readonly__1GNas","disabled":"Textarea_disabled__2oN51"};